export const MODE = process.env.REACT_APP_MODE;
export const isDealerMode = () => MODE === "dealer";

console.log(MODE);
